import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -14","key":"svg-0"}],["path",{"d":"M3 19h2.25c3.728 0 6.75 -3.134 6.75 -7s3.022 -7 6.75 -7h2.25","key":"svg-1"}]]

const IconContrast2 = createReactComponent('outline', 'contrast-2', 'Contrast2', __iconNode);

export default IconContrast2;